/// <amd-module name="typeahead/core/logging/CollectorTransport"/>

export class CollectorTransport {
    public log(payload: any, topic: string) {
        let isBatch = true;
        if (!Array.isArray(payload)) {
            isBatch = false;
        }
        const url = "//"
            + window.location.hostname
            + (window.location.port ? ":" + window.location.port : "")
            + "/cl/data"
            + "/"
            + topic
            + ".json?stream=true&persist=true&batch=" + (isBatch ? "true" : "false");
        $.ajax({
                contentType: "application/json; charset=UTF-8",
                data: JSON.stringify(payload),
                dataType: "json",
                type: "POST",
                url,
            },
        );
    }
}
